import { Button, Dialog, IDialogProps, Tray } from '@busybusy/webapp-react-ui';
import { ArrowBackIcon } from 'assets/icons';
import classNames from 'classnames';
import { Header, HeaderDialog, IconButton } from 'components';
import ConfirmationDialog from 'components/foundation/dialogs/ConfirmationDialog/ConfirmationDialog';
import useQuickTimeTemplates from 'containers/quick-time/hooks/useQuickTimeTemplates';
import { useOpenable } from 'hooks';
import { t } from 'utils/localize';
import QuickTimeTemplateList from '../QuickTimeTemplateList/QuickTimeTemplateList';
import QuickTimeTemplateCreateForm from '../forms/QuickTimeTemplateCreateForm/QuickTimeTemplateCreateForm';
import './QuickTimeTemplateListDialog.scss';

export type QuickTimeTemplateListDialogProps = Omit<IDialogProps, 'children'>;

const TEMPLATE_LIMIT = 30;

function QuickTimeTemplateListDialog({ onClose, className, ...dialogProps }: QuickTimeTemplateListDialogProps) {
  const { templates } = useQuickTimeTemplates(true);
  const createOpenable = useOpenable();
  const templateLimitReachedOpenable = useOpenable();
  const classes = classNames('quick-time-template-create-dialog', className);

  function onCreateClick() {
    if (Object.keys(templates).length >= TEMPLATE_LIMIT) {
      templateLimitReachedOpenable.open();
    } else {
      createOpenable.open();
    }
  }

  return (
    <>
      <Dialog onClose={onClose} className={classes} {...dialogProps}>
        <Header>
          <Tray>
            <IconButton svg={ArrowBackIcon} onClick={onClose} />
            <h2>{t('Time Entry Templates')}</h2>
          </Tray>
        </Header>
        <Header>
          <Button type="secondary" onClick={onCreateClick}>
            + {t('Create')}
          </Button>
        </Header>
        <QuickTimeTemplateList />
      </Dialog>
      <HeaderDialog title={t('Create Template')} isOpen={createOpenable.isOpen} onClose={createOpenable.close}>
        <QuickTimeTemplateCreateForm onSubmit={createOpenable.close} className="mx-8 my-5" />
      </HeaderDialog>
      <ConfirmationDialog
        isOpen={templateLimitReachedOpenable.isOpen}
        onClose={templateLimitReachedOpenable.close}
        onConfirm={templateLimitReachedOpenable.close}
        title={t('Template Limit Reached')}
        message={t(
          'You’ve reached the limit of {{limit}} time entry templates. Delete an existing template before creating a new one.',
          { limit: TEMPLATE_LIMIT }
        )}
        confirmButtonText={t('OK')}
      />
    </>
  );
}

export default QuickTimeTemplateListDialog;
